// フォント
(function(d) {
    var config = {
      kitId: 'ruv5wwt',
      scriptTimeout: 3000,
      async: true
    },
    h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
  })(document);

// fvのスライダー
const fvSwiper = new Swiper('.fv_container .swiper', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,
  speed: 500,
    autoplay: {
      delay: 5000,
    },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 1.5,
      spaceBetween: 120,
    },
    767: {
      slidesPerView: 1.5,
      spaceBetween: 60,
    }
  }
});

const sellerSwiper = new Swiper('.seller_content .swiper', {
  slidesPerView: 2,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  // loop: true,
  // speed: 8000,
  //   autoplay: {
  //     delay: 0,
  //   },
  breakpoints: {
    1024: {
      slidesPerView: 4.5,
    },
    767: {
      slidesPerView: 3.5,
      spaceBetween: 40,
    }
  }
});

// 特集カテゴリースライダー
// スマホの時だけSwiperの機能を削除
(function() {
  const breakPoint = window.matchMedia('(max-width: 767px)');
  let categorySwiper;

  const breakPointChecker = function() {
    if(breakPoint.matches === true) {
      if(categorySwiper !== undefined) {
        categorySwiper.destroy(true, true);
        return;
      }
    } else if(breakPoint.matches === false) {
      return enableSwiper();
    }
  };

  const enableSwiper = function() {
    categorySwiper = new Swiper('.featured_category_content .swiper', {
    slidesPerView: 3,
    spaceBetween: 40,
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 60,
      },
    }
  });
  };

  breakPoint.addListener(breakPointChecker);
  breakPointChecker();
})();

const sellerItems = document.querySelectorAll('.seller_item');
const sellerItemBtns = document.querySelectorAll('.seller_item .card__inner a');
sellerItems.forEach((sellerItem, el) => {
  sellerItem.addEventListener('click', () => {
    sellerItemBtns[el].click();
  });
});


const sliderContentSwiper = new Swiper('.slider_content .swiper', {
  slidesPerView: 2,
  spaceBetween: 20,
  loop: true,
  speed: 500,
  autoplay: {
    delay: 7000,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1250: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    }
  }
});

const product = document.querySelector('body:has(.product)');
if(product) {
  const buyBtn = document.querySelector('.product-form__submit');
  const cartBtn = document.querySelector('.cart_box');
  
  cartBtn.addEventListener('click', () => {
    buyBtn.click();
  });
  
}
